import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/Order.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/grid',
    name: 'grid',
    component: () => import('../views/Grid.vue')
  },
  {
    path: '/breckenridge',
    name: 'breckenridge',
    component: () => import('../views/locations/Breckenridge.vue')
  },
  {
    path: '/chaparral',
    name: 'chaparral',
    component: () => import('../views/locations/Chaparral.vue')
  },
  {
    path: '/foothills',
    name: 'foothills',
    component: () => import('../views/locations/Foothills.vue')
  },
  {
    path: '/presbyterian',
    name: 'presbyterian',
    component: () => import('../views/locations/Presbyterian.vue')
  },
  {
    path: '/parker',
    name: 'parker',
    component: () => import('../views/locations/Parker.vue')
  },
  {
    path: '/stjohn',
    name: 'stjohn',
    component: () => import('../views/locations/StJohn.vue')
  },
  {
    path: '/riverdale',
    name: 'riverdale',
    component: () => import('../views/locations/Riverdale.vue')
  },
  {
    path: '/windsor',
    name: 'windsor',
    component: () => import('../views/locations/Windsor.vue')
  },
  {
    path: '/lyons',
    name: 'lyons',
    component: () => import('../views/locations/Lyons.vue'),
  },
  {
    path: '/boulder',
    name: 'boulder',
    component: () => import('../views/locations/Boulder.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
